import "./dashboard.css";
import React, { useState, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import TokenService from "../../services/token.service.js";
import sidebarMenu from "../../components/Sidebar/sidebarList.js";
import footerNavList from "../../components/Footer/footerNavList.js";
import { Header, Sidebar, FooterNav } from "../../components";
import { CardinalstoneLogo } from "../../assets";
import { useAppContext } from "../../context/AppContext.js";

function Dashboard() {
	const { desktopView } = useAppContext();
	const navigate = useNavigate();
	const [user, setUser] = useState("");

	// Guarded Route:
	useEffect(() => {
		const token = TokenService.getToken("token");
		const user = TokenService.getUser("user");

		if (!token) {
			navigate("/");
		} else if (user?.groups?.length === 0) {
			navigate("/403");
		}

		const userName = user?.name;
		setUser(userName);
	}, [navigate]);

	// Set page title:
	useEffect(() => {
		document.title = "Event Dashboard";
	}, []);

	return (
		<>
			{desktopView ? (
				<main className="dashboard">
					<Sidebar sidebarMenu={sidebarMenu} />
					<main className="dashboard_main">
						<Header user={user} />
						<section className="dashboard_content">
							<Outlet />
						</section>
					</main>
				</main>
			) : (
				<main className="dashboard">
					<main className="dashboard_main">
						<div className="dashboard_logo mobile">
							<img src={CardinalstoneLogo} alt="Cardinalstone Logo" />
						</div>
						<section className="dashboard_content">
							<Outlet />
						</section>
						<FooterNav bottomNavBarMenu={footerNavList} />
					</main>
				</main>
			)}
		</>
	);
}

export default Dashboard;
